export default __webpack_public_path__ + "static/media/Contacto-manuable.4f4d0e17.png";